import { confirmDialog } from '../../components/ConfirmationDialog'

const useConfirmationDialog = () => {
  return {
    confirm: confirmDialog,
  }
}

export default useConfirmationDialog
